import { render, staticRenderFns } from "./RichTextArea.vue?vue&type=template&id=7b45bd52&scoped=true"
import script from "./RichTextArea.vue?vue&type=script&lang=ts"
export * from "./RichTextArea.vue?vue&type=script&lang=ts"
import style0 from "./RichTextArea.vue?vue&type=style&index=0&id=7b45bd52&prod&scoped=true&lang=postcss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b45bd52",
  null
  
)

export default component.exports